// import { useNavigate, Link } from "react-router-dom";
// import { IoArrowForward, IoTimeOutline, IoShieldCheckmarkOutline, IoPeopleOutline, IoInformationCircleOutline } from "react-icons/io5";
// import Header from "../Components/Header";
// import Footer from "../Components/Footer";

// const FEATURES = [
//   {
//     icon: IoTimeOutline,
//     title: "5 Minutes",
//     text: "A quick, streamlined questionnaire designed to respect your time.",
//   },
//   {
//     icon: IoShieldCheckmarkOutline,
//     title: "Strictly Confidential",
//     text: "HIPAA & GDPR compliant. Your individual data is never shared with your employer.",
//   },
//   {
//     icon: IoPeopleOutline,
//     title: "Anonymized Insights",
//     text: "Your employer only sees aggregate trends to improve overall workplace wellness programs.",
//   },
// ];

// const HraPage = () => {
//   const navigate = useNavigate();
//   const year = new Date().getFullYear();

//   return (
//     <div className="bg-background min-h-screen flex flex-col">
//       <Header />

//       <div className="flex-1 flex flex-col pb-16 lg:pb-0">
//         <section className="px-3 sm:px-6 py-8 sm:py-16">
//           <div className="max-w-3xl mx-auto card p-6 sm:p-10 lg:p-12 shadow-md">
//             <div className="flex flex-col items-center text-center">
//               <span className="inline-flex items-center justify-center gap-1.5 bg-primary text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6">
//                 <span className="w-1.5 h-1.5 rounded-full bg-white" />
//                 Annual Requirement
//               </span>
//               <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-on-primary-fixed-var mb-4 max-w-lg">
//                 Your {year} Health Risk Assessment
//               </h1>
//               <p className="text-on-surface-variant text-sm sm:text-base mb-10 max-w-md leading-relaxed">
//                 Take control of your wellbeing. This quick, confidential assessment helps us tailor personalized health recommendations just for you.
//               </p>
//               <div className="flex justify-center w-full">
//                 <button
//                   type="button"
//                   onClick={() => navigate("/hra-questions")}
//                   className="btn-primary inline-flex items-center gap-2 px-10 py-3.5 text-base shadow-sm"
//                 >
//                   Start Assessment
//                   <IoArrowForward size={18} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </section>

//         <section className="max-w-5xl mx-auto w-full px-3 sm:px-6 pb-6 sm:pb-8 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
//           {FEATURES.map(({ icon: Icon, title, text }) => (
//             <div key={title} className="card p-4 sm:p-6 text-center min-h-[140px] sm:min-h-[160px] flex flex-col items-center">
//               <div className="w-12 h-12 mb-4 rounded-full bg-surface-low flex items-center justify-center">
//                 <Icon className="text-on-surface-variant" size={22} />
//               </div>
//               <h3 className="font-semibold text-on-primary-fixed-var mb-2">{title}</h3>
//               <p className="text-sm text-on-surface-variant leading-relaxed">{text}</p>
//             </div>
//           ))}
//         </section>

//         <section className="max-w-5xl mx-auto w-full px-3 sm:px-6 pb-8 sm:pb-12">
//           <div className="flex flex-col sm:flex-row items-center justify-center gap-3 bg-surface-low rounded-xl p-4 sm:p-5 border border-surface-container text-center sm:text-left">
//             <IoInformationCircleOutline className="text-primary shrink-0" size={20} />
//             <p className="text-xs sm:text-sm text-on-surface-variant">
//               By clicking &apos;Start Assessment&apos;, you agree to our{" "}
//               <Link to="/termsandconditions" className="text-primary underline font-medium">Terms of Service</Link>
//               {" "}and{" "}
//               <Link to="/privacyandpolicy" className="text-primary underline font-medium">Privacy Policy</Link>
//               {" "}regarding the handling of your health information.
//             </p>
//           </div>
//         </section>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default HraPage;


import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { IoArrowForward, IoTimeOutline, IoShieldCheckmarkOutline, IoPeopleOutline, IoInformationCircleOutline } from "react-icons/io5";
import { getHraCategories } from "../api/hra.api";
import { getStaffId, getGender } from "../utils/storage";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const FEATURES = [
  {
    icon: IoTimeOutline,
    title: "5 Minutes",
    text: "A quick, streamlined questionnaire designed to respect your time.",
  },
  {
    icon: IoShieldCheckmarkOutline,
    title: "Strictly Confidential",
    text: "HIPAA & GDPR compliant. Your individual data is never shared with your employer.",
  },
  {
    icon: IoPeopleOutline,
    title: "Anonymized Insights",
    text: "Your employer only sees aggregate trends to improve overall workplace wellness programs.",
  },
];

const HraPage = () => {
  const [hasCategories, setHasCategories] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const staffId = getStaffId();
  const gender = getGender();
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  useEffect(() => {
    if (!staffId) {
      setError("Staff ID not found.");
      return;
    }
    setLoading(true);
    getHraCategories(staffId)
      .then((response) => {
        const list = response.data.hras || [];
        const filtered = list.filter((item) => {
          if (gender === "Male") return item.gender !== "Female";
          return true;
        });
        setHasCategories(filtered.length > 0);
        setLoading(false);
      })
      .catch(() => {
        setError("Error fetching HRA data");
        setLoading(false);
      });
  }, [staffId, gender]);

  const handleStart = () => navigate("/hra-questions");

  return (
    <div className="bg-background min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 flex flex-col pb-16 lg:pb-0">
        <section className="px-3 sm:px-6 py-8 sm:py-16">
          <div className="max-w-3xl mx-auto card p-6 sm:p-10 lg:p-12 shadow-md">
            <div className="flex flex-col items-center text-center">
              <span className="inline-flex items-center justify-center gap-1.5 bg-primary text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6">
                <span className="w-1.5 h-1.5 rounded-full bg-white" />
                Annual Requirement
              </span>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-on-primary-fixed-var mb-4 max-w-lg">
                Your {year} Health Risk Assessment
              </h1>
              <p className="text-on-surface-variant text-sm sm:text-base mb-10 max-w-md leading-relaxed">
                Take control of your wellbeing. This quick, confidential assessment helps us tailor personalized health recommendations just for you.
              </p>
              <div className="flex justify-center w-full">
                <button
                  onClick={handleStart}
                  disabled={loading || !hasCategories}
                  className="btn-primary inline-flex items-center gap-2 px-10 py-3.5 text-base shadow-sm disabled:opacity-50"
                >
                  Start Assessment
                  <IoArrowForward size={18} />
                </button>
              </div>
              {error && <p className="text-error text-sm mt-4">{error}</p>}
            </div>
          </div>
        </section>

        <section className="max-w-5xl mx-auto w-full px-3 sm:px-6 pb-6 sm:pb-8 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
          {FEATURES.map(({ icon: Icon, title, text }) => (
            <div key={title} className="card p-4 sm:p-6 text-center min-h-[140px] sm:min-h-[160px] flex flex-col items-center">
              <div className="w-12 h-12 mb-4 rounded-full bg-surface-low flex items-center justify-center">
                <Icon className="text-on-surface-variant" size={22} />
              </div>
              <h3 className="font-semibold text-on-primary-fixed-var mb-2">{title}</h3>
              <p className="text-sm text-on-surface-variant leading-relaxed">{text}</p>
            </div>
          ))}
        </section>

        <section className="max-w-5xl mx-auto w-full px-3 sm:px-6 pb-8 sm:pb-12">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 bg-surface-low rounded-xl p-4 sm:p-5 border border-surface-container text-center sm:text-left">
            <IoInformationCircleOutline className="text-primary shrink-0" size={20} />
            <p className="text-xs sm:text-sm text-on-surface-variant">
              By clicking &apos;Start Assessment&apos;, you agree to our{" "}
              <Link to="/termsandconditions" className="text-primary underline font-medium">Terms of Service</Link>
              {" "}and{" "}
              <Link to="/privacyandpolicy" className="text-primary underline font-medium">Privacy Policy</Link>
              {" "}regarding the handling of your health information.
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default HraPage;
